/* eslint-disable */

import React from 'react';
import { RotatingLines } from 'react-loader-spinner';
import './ModalPopup.css';

class ModalLoad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        {this.props.option.enable === true ? (
          <>
            <div className='meya-modal-loading'>
              <div className='meya-modal-loading-body text-center'>
                <div className='meya-modal-loading-header font-th'>กรุณารอสักครู่</div>
                <div className='meya-modal-loading-content font-th mb-5'>
                  {this.props.option.message}
                </div>
                <RotatingLines
                  strokeColor='grey'
                  strokeWidth='3'
                  animationDuration='0.75'
                  width='50'
                  visible={true}
                />
              </div>
            </div>
            {this.props.backdrop !== undefined ? (
              this.props.backdrop === true ? (
                this.props.option.transparent !== undefined ? (
                  this.props.option.transparent === true ? (
                    <div className='meya-backdrop-loading-trans'></div>
                  ) : (
                    <div className='meya-backdrop-loading'></div>
                  )
                ) : (
                  <div className='meya-backdrop-loading'></div>
                )
              ) : null
            ) : (
              <div className='meya-backdrop-loading'></div>
            )}
          </>
        ) : null}
      </>
    );
  }
}

export default ModalLoad;
